import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import ComponentAccordion from './componentAccordion.js';
import ComponentAccordionItem from './componentAccordionItem.js';

/**
 * @typedef {import('../../App.d.ts').GroupedAccordionProps} GroupedAccordionProps
 */
/**
 *
 * @param {GroupedAccordionProps} props
 * @returns {Element}
 * @constructor
 */
export default (props) => (
  <div
    data-testid="grouped-accordion"
    className="ebds-grouped-accordion"
  >
    <Container>
      <h2 className="ebds-heading--with-subheadline-first">
        <span>{props.subheadline}</span>
        {props.headline}
      </h2>
      <div className="ebds-grouped-accordion__items">
        {props.items.map((entry) => (
          <div
            key={entry.sys.id}
            className="ebds-grouped-accordion__items__item"
          >
            <ComponentAccordion
              headline={entry.fields.headline}
              isGroupItem
            >
              {entry.fields.components.map((item) => (
                <ComponentAccordionItem
                  key={item.sys.id}
                  summary={item.fields.summary}
                  detailRaw={item.fields.detailRaw}
                />
              ))}
            </ComponentAccordion>
          </div>
        ))}
      </div>
    </Container>
  </div>
);
